import axios from "axios";

let $axios;

const isLocalhost = new RegExp("localhost", "ig").test(location.host);

$axios = axios.create({
  baseURL: isLocalhost
    ? "http://localhost:4080/api/" // Оставляем для удобной разработки на домашнем ПК
    : "/api/"                      // Для сервера: браузер сам подставит домен и https://
});

export default $axios;